export default __webpack_public_path__ + "static/media/4.c55003e2.jpg";